import React, { useEffect, useRef, useState, useCallback } from 'react';
import './NFT.css';
import { useDaily, useLocalSessionId } from '@daily-co/daily-react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { pageAtom, myNftAtom, myNftBackAtom, isAuthAtom, nftDetailAtom } from '../../State';
import { ReactComponent as SelectedSVG } from '../Images/buttons/nftSelected.svg';
import { ReactComponent as SelectedBackSVG } from '../Images/buttons/selectedBack.svg';

import DataModel from '../Util/DataModel';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import isElectron from '../../Global';
import AddAccess from '../Util/AddAccess';
import { getImagePath } from '../Util/utils';

export default function NFTItem(props) {
  //Daily系
  const callObject = useDaily();
  const localSessionID = useLocalSessionId();

  //Recoil系
  const [myNftState, setMyNftState] = useRecoilState(myNftAtom);
  const [myNftBackState, setMyNftBackState] = useRecoilState(myNftBackAtom);
  const [isAuthState, setAuthState] = useRecoilState(isAuthAtom);
  const setNftDetailPageState = useSetRecoilState(nftDetailAtom);

  //その他
  const [loadingState, setLoadingState] = useState(false);
  var isSelected = false;
  var isBackgroundSelected = false;

  async function selectNFT() {
    // let imageURL = 'https://d2wp3sepl8g4xv.cloudfront.net/model/images/' + props.nftID + '.png';
    setMyNftState(props.nftID);

    //ローカルストレージに保存
    localStorage.setItem('imageURL', props.nftID);

    //ローカルストレージに保存
    localStorage.setItem('nftID', props.nftID);

    //ローカルストレージに保存
    localStorage.setItem('nftWhoCanUse', props.limit);

    //エレクトロンの場合
    if (isElectron) {
      await window.myapi.imageChange(props.nftID);
    }

    if (isAuthState) {
      //データベースに保存(usersに保存)
      await DataModel.saveUserData('imageURL', props.nftID, props.nftID);

      //オリジナルNFTの場合
      // if (props.type != 'partner') {
      //   //データベースに保存(nftに保存)
      //   DataModel.saveNFT(props.nftData);
      // }
    }

    //セッション内入っている場合は、セッションデータベースも更新
    if (callObject != null) {
      callObject
        .getMeetingSession()
        .then(async (session) => {
          try {
            //自分の情報をseessionに登録
            await DataModel.saveSessionToRoom(
              null, //ルームID
              session.meetingSession.id, //ルームのセッションID
              localSessionID, //ユーザーのテンポラリーユーザーID
              props.nftID, //顔
              null, //背景
              null,
              null,
              null,
              props.limit, //誰が使えるか
            );

            console.log('セッション保存完了');

            //アクセス
            AddAccess('click', 'nftItem', props.nftID);
          } catch (error) {
            console.log(error);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      //アクセス
      AddAccess('click', 'nftItem', props.nftID);
    }
  }

  //NFTアイテムをタップ時
  const tapNFTItem = async () => {
    //設定ページを閉じる
    //setPageState('main');

    //すべてのホルダーかユニークホルダーの場合

    if (props.type == 'uniqueList') {
      //props.setIsShowUniqueState(true);

      props.setUniqueState(props.uniqueState);
    } // else if (props.limit == 'allholders') {
    else if (props.allow == 'ok') {
      selectNFT();
    } else if (props.limit == 'allholders' || props.limit == 'uniqueholder') {
      // } else if (props.limit == 'anyone') {
      setNftDetailPageState({
        show: true,
        nftID: props.nftID,
        nftWhoCanUse: props.limit,
      });
    } else if (props.type == 'detail') {
      props.setNFTPartnerDetailID(props.nftID);
    }

    //顔選択の場合
    else if (props.type == 'pro' || props.allow == 'ok') {
      selectNFT();
    }
    //背景の場合
    else if (props.type == 'back') {
      //let imageURL = 'https://d2wp3sepl8g4xv.cloudfront.net/model/images/back/' + props.nftID + '.png';

      //全体に設定
      setMyNftBackState(props.imageURL);

      //ローカルストレージに保存
      localStorage.setItem('backImageURL', props.imageURL);

      //データベースに保存(usersに保存)
      if (isAuthState) {
        DataModel.saveUserData('backImage', props.imageURL);
      }

      //セッション内入っている場合は、セッションデータベースも更新
      callObject
        .getMeetingSession()
        .then(async (session) => {
          //自分の情報をseessionに登録
          DataModel.updateSessionToRoom(session.meetingSession.id, 'backImage', props.imageURL);
        })
        .catch((error) => {
          console.log(error);
        });

      //アクセス
      AddAccess('click', 'nftBackImage', props.imageURL);
    }
  };

  var finalImageURL = props.imageURL;

  //顔の場合
  if (props.type == 'pro') {
    if (props.nftID == null) {
      finalImageURL = 'https://d2wp3sepl8g4xv.cloudfront.net/model/images/default.png';
    } else if (props.nftID.startsWith('custom')) {
      finalImageURL =
        'https://storage.googleapis.com/faceless-97bcf.appspot.com/generate/' +
        props.nftID +
        '.png';
    } else {
      finalImageURL =
        'https://d2wp3sepl8g4xv.cloudfront.net/model/images/t/' + props.nftID + '.png';
    }
  }

  //ユニークリストの場合
  if (props.type == 'uniqueList') {
    finalImageURL = 'https://d2wp3sepl8g4xv.cloudfront.net/model/images/' + props.imageURL + '.png';
  }

  //背景の場合
  if (props.type == 'back') {
    //カスタムの場
    if (props.imageURL.startsWith('custom')) {
      let fileType = props.imageURL.split('.').pop();

      //動画の場合
      if (fileType == 'mp4') {
        finalImageURL = getImagePath() + '/background/videoThumb.png';
      }
      //その他画像の場合
      else {
        finalImageURL =
          'https://storage.googleapis.com/faceless-97bcf.appspot.com/mybackground/' +
          props.imageURL;
      }
    }
    //通常の場合
    else {
      finalImageURL = 'https://d2wp3sepl8g4xv.cloudfront.net/backImages/' + props.imageURL; //props.thumbURL;
      finalImageURL = getImagePath() + '/background/' + props.imageURL;
    }
  }

  //NFTデータの場合
  if (props.nftData != null) {
    if (props.nftData.smallImageURL != null) {
      finalImageURL = props.nftData.smallImageURL;
    }
  }

  //選択中かどうか
  if (myNftState == props.nftID || localStorage.getItem('nftID') == props.nftID) {
    if (props.type != 'back') {
      isSelected = true;
    }
  }

  //選択中かどうか
  if (myNftBackState == props.imageURL || localStorage.getItem('backImageURL') == props.imageURL) {
    isBackgroundSelected = true;
  }

  //画像のローディング完了トリガー
  const loadCompleted = async () => {
    setLoadingState(true);
  };

  //フェイス一覧のレンダー
  if (props.showType == 'partnerList') {
    return (
      <>
        <div className="nftPartnerItem" onClick={tapNFTItem}>
          <div className="relativeBox">
            <img
              src={finalImageURL}
              onError={(e) => (e.target.style.display = 'none')}
              onLoad={loadCompleted}
              style={{
                borderRadius: props.type == 'back' || props.type == 'uniqueList' ? '7px' : '50%',
                display: !loadingState ? 'none' : 'inline-block',
              }}
            />

            {isSelected && (
              <div className="nftSelected">
                <SelectedSVG />
              </div>
            )}

            {props.limit == 'allholders' && (
              <div className="holderBadge">
                <img src={getImagePath() + '/icons/holdersIcon.png'} />
              </div>
            )}

            {props.limit == 'uniqueholder' && (
              <div className="holderBadge">
                <img src={getImagePath() + '/icons/uniqueHolderIcon.png'} />{' '}
              </div>
            )}
          </div>

          <div className="nftPartnerBottom">
            <div className="nftPartnerName">{props.nftName}</div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="nftItem">
        <img
          src={finalImageURL}
          onClick={tapNFTItem}
          onError={(e) => (e.target.style.display = 'none')}
          onLoad={loadCompleted}
          style={{
            borderRadius: props.type == 'back' || props.type == 'uniqueList' ? '7px' : '50%',
            display: !loadingState ? 'none' : 'block',
          }}
        />

        {isSelected && (
          <div className="nftSelected">
            <SelectedSVG />
          </div>
        )}

        {isBackgroundSelected && (
          <div className="nftSelected">
            <SelectedBackSVG />
          </div>
        )}
        {!loadingState && (
          <>
            {props.type != 'back' ? (
              <Skeleton
                circle={true}
                baseColor={'#ccc'}
                highlightColor={'#fff'}
                height={'50px'}
                width={'50px'}
              />
            ) : (
              <Skeleton baseColor={'#ccc'} highlightColor={'#fff'} height={'80px'} width={'100%'} />
            )}
          </>
        )}
      </div>
    </>
  );
}
